<template>

    <div style="width:100%">
        <div class="iwd-option-btn" :class="{active: selected_plan === 'monthly'}" @click="selectPlan('monthly')">Monthly - &pound;{{ costs.monthly.per_month }} per month</div>
        <div class="iwd-option-btn" :class="{active: selected_plan === 'annual'}" @click="selectPlan('annual')">Annual - &pound;{{ costs.annual.per_month }} per month <span v-if="!referral">(save 20%)</span></div>
        <input type="hidden" name="selected_plan" v-model="selected_plan">

        <div class="form-row pull-right">
            <button type="submit" class="primary-form-button" :disabled="selected_plan === null" @click="submitForm()">Next</button>
        </div>
    </div>

</template>

<script>

export default {
	data(){
		return {
            selected_plan: null
        }
    },
    props: [
        'costs',
        'referral'
    ],
    computed: {
        discountedMonthlyPrice() {
            const originalPrice = this.costs.monthly.per_month;
            const discount = 0.2; // 20% discount
            const discountedAmount = originalPrice * discount;
            const discountedPrice = originalPrice - discountedAmount;
            return discountedPrice;
        },
        discountedAnnualPrice() {
            const originalPrice = this.costs.annual.per_month;
            const discount = 0.2; // 20% discount
            const discountedAmount = originalPrice * discount;
            const discountedPrice = originalPrice - discountedAmount;
            return discountedPrice;
        }
    },
    methods: {
		selectPlan(plan){
			this.selected_plan = plan;
        },
        submitForm(){
            $('form#chosen-plan').submit();
        }
    }
}

</script>
